var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41749 29.3192L10.9755 25.7612C11.7993 24.9374 11.7993 23.601 10.9755 22.7772L9.76143 21.5632C8.93762 20.7394 7.60125 20.7394 6.77743 21.5632L3.21945 25.1212C2.39564 25.945 2.39564 27.2814 3.21945 28.1052L4.43349 29.3192C5.2573 30.143 6.59368 30.143 7.41749 29.3192ZM25.7613 10.9754L29.3192 7.41746C30.1431 6.59365 30.1431 5.25727 29.3192 4.43346L28.1052 3.21942C27.2814 2.39561 25.945 2.39561 25.1212 3.21942L21.5632 6.77741C20.7394 7.60122 20.7394 8.93759 21.5632 9.7614L22.7773 10.9754C23.6011 11.7993 24.9374 11.7993 25.7613 10.9754ZM9.76092 10.9754L10.975 9.7614C11.7988 8.93759 11.7988 7.60122 10.975 6.77741L7.41697 3.21942C6.59316 2.39561 5.25679 2.39561 4.43297 3.21942L3.21893 4.43346C2.39512 5.25727 2.39512 6.59365 3.21893 7.41746L6.77692 10.9754C7.60073 11.7993 8.9371 11.7993 9.76092 10.9754ZM28.1047 29.3192L29.3187 28.1052C30.1425 27.2814 30.1425 25.945 29.3187 25.1212L25.7607 21.5632C24.9369 20.7394 23.6006 20.7394 22.7767 21.5632L21.5627 22.7772C20.7389 23.601 20.7389 24.9374 21.5627 25.7612L25.1207 29.3192C25.9445 30.143 27.2809 30.143 28.1047 29.3192Z",
    fill: "url(#paint0_linear_1640_38269)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7736 27.7736C34.1272 21.42 34.1272 11.1188 27.7736 4.76518C21.42 -1.58839 11.1188 -1.58839 4.76518 4.76518C-1.58839 11.1188 -1.58839 21.42 4.76518 27.7736C11.1188 34.1272 21.42 34.1272 27.7736 27.7736ZM23.2452 23.2452C19.3925 27.0979 13.1463 27.0979 9.29409 23.2452C5.44137 19.3925 5.44137 13.1463 9.29409 9.29409C13.1468 5.44137 19.393 5.44137 23.2452 9.29409C27.0979 13.1468 27.0979 19.393 23.2452 23.2452Z",
    fill: "url(#paint1_linear_1640_38269)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_38269",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7736 27.7736C34.1272 21.42 34.1272 11.1188 27.7736 4.76518C21.42 -1.58839 11.1188 -1.58839 4.76518 4.76518C-1.58839 11.1188 -1.58839 21.42 4.76518 27.7736C11.1188 34.1272 21.42 34.1272 27.7736 27.7736ZM23.2452 23.2452C19.3925 27.0979 13.1463 27.0979 9.29409 23.2452C5.44137 19.3925 5.44137 13.1463 9.29409 9.29409C13.1468 5.44137 19.393 5.44137 23.2452 9.29409C27.0979 13.1468 27.0979 19.393 23.2452 23.2452Z",
    fill: "url(#paint2_linear_1640_38269)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_38269)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1640_38269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41749 29.3192L10.9755 25.7612C11.7993 24.9374 11.7993 23.601 10.9755 22.7772L9.76143 21.5632C8.93762 20.7394 7.60125 20.7394 6.77743 21.5632L3.21945 25.1212C2.39564 25.945 2.39564 27.2814 3.21945 28.1052L4.43349 29.3192C5.2573 30.143 6.59368 30.143 7.41749 29.3192ZM25.7613 10.9754L29.3192 7.41746C30.1431 6.59365 30.1431 5.25727 29.3192 4.43346L28.1052 3.21942C27.2814 2.39561 25.945 2.39561 25.1212 3.21942L21.5632 6.77741C20.7394 7.60122 20.7394 8.93759 21.5632 9.7614L22.7773 10.9754C23.6011 11.7993 24.9374 11.7993 25.7613 10.9754ZM9.76092 10.9754L10.975 9.7614C11.7988 8.93759 11.7988 7.60122 10.975 6.77741L7.41697 3.21942C6.59316 2.39561 5.25679 2.39561 4.43297 3.21942L3.21893 4.43346C2.39512 5.25727 2.39512 6.59365 3.21893 7.41746L6.77692 10.9754C7.60073 11.7993 8.9371 11.7993 9.76092 10.9754ZM28.1047 29.3192L29.3187 28.1052C30.1425 27.2814 30.1425 25.945 29.3187 25.1212L25.7607 21.5632C24.9369 20.7394 23.6006 20.7394 22.7767 21.5632L21.5627 22.7772C20.7389 23.601 20.7389 24.9374 21.5627 25.7612L25.1207 29.3192C25.9445 30.143 27.2809 30.143 28.1047 29.3192Z",
    fill: "url(#paint3_linear_1640_38269)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1640_38269",
    x: -0.398926,
    y: -0.398438,
    width: 33.3359,
    height: 33.3359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1640_38269"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38269",
    x1: 16.2697,
    y1: 29.9372,
    x2: 16.2693,
    y2: 2.60133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CCFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_38269",
    x1: 27.7736,
    y1: 4.76467,
    x2: 4.76467,
    y2: 27.7736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_38269",
    x1: 27.7736,
    y1: 4.76467,
    x2: 4.76467,
    y2: 27.7736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_38269",
    x1: 16.2697,
    y1: 29.9372,
    x2: 16.2693,
    y2: 2.60133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CCFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFeedback);
export default __webpack_public_path__ + "static/media/menu-feedback.f09ffa117931d4cec64f11ff83476644.svg";
export { ForwardRef as ReactComponent };